import { withInstall } from "@xplus/utils/with-install";
import transfer from "./src/transfer.vue";
export const xTransfer = withInstall(transfer);
export default xTransfer;
